module.exports = __webpack_public_path__ + "img/jiaotongtopnew.a31bcddd.png";